import React, { useState, useContext } from 'react'
import { connect } from 'react-redux'
import isNil from 'lodash/isNil'
import './index.scss'
import { waitForGoogleMaps } from '../maploader/maploader'

let friendLocationMarker;

waitForGoogleMaps(() => {
  friendLocationMarker = class extends google.maps.OverlayView {
    constructor(position, msg, image, map, toggleInfo) {
      super()
      this.position = position
      this.image = image
      this.div = null
      this.setMap(map)
      this.active = false
      this.data = msg
      this.toggleInfo = toggleInfo
    }

    draw() {
      if (this.div == null) {
        this.div = document.createElement('div')
        const img = document.createElement('img')
        this.div.classList.add('friend-location-container')
        img.classList.add('friend-location-image')
        img.src = this.image
        this.div.appendChild(img)

        friendLocationMarker.preventMapHitsAndGesturesFrom(this.div)
        const panes = this.getPanes()
        panes.overlayMouseTarget.appendChild(this.div)
        this.div.onclick = (e) => {
          e.preventDefault()
          this.toggleInfo(this.data.FromUserId)
        }
      }
      let point = null
      try {
        point = this.getProjection().fromLatLngToDivPixel(this.position)
      } catch (error) {
        console.log('no projection')
      }
      if (point) {
        this.div.style.left = point.x + 'px'
        this.div.style.top = point.y + 'px'
      }
    }
    remove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div)
        this.div = null
      }
    }
    setPosition(latLng) {
      this.position = latLng
      this.draw()
    }
  }
}
)

class RenderFriends extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      friendLocations: props.userPreferences.friendLocations,
      active: false
    }
    this.friendMarkers = {}
  }

  toggleInfo(id) {
    const { setFeatureData, clearFeatureData } = this.props,
      marker = this.friendMarkers[id]
    if (this.state.active) {
      clearFeatureData()
      this.setState({ active: false })
    } else {
      this.setState({ active: true }, () => {
        setFeatureData({
          position: new google.maps.LatLng({ lat: parseFloat(marker.data.Lat), lng: parseFloat(marker.data.Lng) }),
          features: [{
            name: marker.data.Fullname,
            properties: {
              latitude: parseFloat(marker.data.Lat).toFixed(6),
              longitude: parseFloat(marker.data.Lng).toFixed(6),
              date: marker.data.date.split(', ')[0],
              time: marker.data.date.split(', ')[1]
            }
          }],
          type: 'friend'
        })
      })
    }
  }

  makeMarkers() {
    const { followers, locationMessage, mapReference, userPreferences } = this.props,
      { friendMarkers } = this
    if (!mapReference) {
      return null
    }
    locationMessage.forEach(msg => {
      const lat = parseFloat(msg.Lat),
        lng = parseFloat(msg.Lng),
        position = new google.maps.LatLng(lat, lng)
      if (!isNil(friendMarkers[msg.FromUserId])) {
        const marker = friendMarkers[msg.FromUserId]
        if (userPreferences.friendLocations) {
          if (marker.getMap() === null) {
            marker.setMap(mapReference)
          }
          marker.setPosition(position)
        } else {
          if (marker.getMap() !== null) {
            marker.setMap(null)
          }
        }
      } else {
        if (userPreferences.friendLocations) {
          const user = followers.find(user => user.id == msg.FromUserId)
          if (user) {
            const markerObj = new friendLocationMarker(position, msg, user.imageProfileUrl, mapReference, this.toggleInfo.bind(this)),
              updated = Object.assign(friendMarkers, { [msg.FromUserId]: markerObj })
            this.friendMarkers = updated
          }
        }
      }
    })
  }
  render() {
    this.makeMarkers()
    return null
  }
}


const mapStateToProps = state => ({
  followers: state.followers,
  locationMessage: state.locationMessage,
  mapReference: state.mapReference(),
  userPreferences: state.userPreferences
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(RenderFriends)